import { UserRole } from '@/store/auth/types';
import { CalculatedTableColumn } from '../types';
import { getColumns } from './columns';

export const getGridColumns = (props: IGridColumnProps, screenWidth: number): CalculatedTableColumn[] => {
  const visibleColumns = getColumns(props)
    .filter(col => col.visible({ role: props.userRole }))
    .map(col => col.item);

  const columnsWithoutAsignedWidth = visibleColumns.filter(col => {
    const width = Number(col.width);
    if (width) {
      screenWidth -= width;

      return false;
    }
    return true;
  }).length;
  const equalWidth = Math.round((screenWidth - 100) / columnsWithoutAsignedWidth);

  return visibleColumns.map(col => {
    if (col.width === undefined && col.responsive !== true) {
      col.width = String(equalWidth);
    }
    col.headerCellClass = `grid-HeaderCell rdg-column-${col.key}`;
    col.cellClass = () => `row grid-Cell`;
    return col;
  });
};

export interface IGridColumnProps {
  userRole: UserRole;
  activeTab: string;
}

export const getColumnsForActiveTab = ({ userRole, activeTab }: IGridColumnProps, screenWidth: number) => {
  const columns = getGridColumns({ userRole, activeTab }, screenWidth);

  return columns;
};
